import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { login } from "../store/api/auth";
import { SpinnerCircular } from "spinners-react";

import visable from "../assets/images/visibility.png";
import unvisable from "../assets/images/unvisibility.png";
import { setCredational } from "../store/ui/loginUi";

export default function AdminLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [passwordType, setPasswordType] = useState("password");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const initialValues = {
    email: "",
    password: "",
  };
  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email format").required("Required"),
    password: Yup.string()
      .required("Required")
      .min(5, "Password is too short - should be 5 chars minimum."),
  });
  const onSubmit = async (values) => {
    setLoading(true);
    dispatch(setCredational(values));

    dispatch(
      login({
        body: {
          email: values.email,
          password: values.password,
        },
        onSuccess: (res) => {
          navigate("/oTPverification");
          setLoading(false);
        },

        onError: (error) => {
          setLoading(false);

          if (error.response) {
            if (error.response.data.errors) {
              for (let key in error.response.data.errors) {
                setError(error.response.data.errors[key]);
              }
            } else if (error.response.data.message) {
              setError(error.response.data.message);
            }
          }
        },
      })
    );
  };
  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, handleChange, handleBlur, handleSubmit }) => (
          <>
            <section className="login_wraper">
              <div className="login_inner">
                <div className="login_logo mb_40">
                  {" "}
                  <img src={Logo} alt="" />{" "}
                </div>
                <h1 className="mb_30 main_title">Admin Login</h1>
                <p className="mb_40 them_para">
                  Please enter valid email and a strong password to proceed with
                  the login process.
                </p>
                <form
                  onSubmit={handleSubmit}
                  action="index_submit"
                  method="get"
                >
                  <div className="form-group icon">
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange("email")}
                      onBlur={handleBlur("email")}
                      value={values.email}
                      className="custom_input form-control"
                      placeholder="Email ID"
                      style={{marginBottom:"15px"}}
                    />{" "}
                    <div
                      style={{
                        color: "red",
                        marginBottom: "15px"
                      }}
                    >
                      <ErrorMessage name="email" />
                    </div>
                  </div>
                  <div class="form-group icon">
                    <input
                      name="password"
                      onChange={handleChange("password")}
                      onBlur={handleBlur("password")}
                      value={values.password}
                      type={passwordType}
                      className="custom_input form-control"
                      placeholder="Password"
                      style={{marginBottom:"15px"}}
                    />
                    <div class="img_icon">
                      {passwordType === "password" ? (
                        <a>
                          <img src={visable} alt="" onClick={togglePassword} />
                        </a>
                      ) : (
                        <a>
                          <img
                            src={unvisable}
                            alt=""
                            onClick={togglePassword}
                          />{" "}
                        </a>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      color: "red",
                    }}
                  >
                    <ErrorMessage name="password" />
                  </div>
                  <div style={{ padding: 2, marginLeft: 40 }}>
                    <h6 style={{ color: "red", alignSelf: "center" }}>
                      {error}
                    </h6>
                  </div>
                  <div className="btn_wraper">
                    <button
                      type="submit"
                      className="them_btn1 mt_40 mb_30"
                      onClick={handleSubmit}
                      disabled={loading ? true : false}
                    >
                      {loading ? (
                        <SpinnerCircular
                          style={{ height: "40", marginTop: "7" }}
                        />
                      ) : (
                        "Login"
                      )}
                    </button>
                  </div>
                </form>
                <Link to="/forgetPassword">
                  <p className="otp-btn-link">Forgot Password?</p>
                </Link>
              </div>
            </section>
          </>
        )}
      </Formik>
    </>
  );
}
